import store from '@store'

export default [
  config => {
    const token = store.state.user.token
    if (token) {
      config.headers.token = token
    }
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  },
]
